<template>
    <div class="d-flex flex-column" id="app">
        <loading v-if="$root.carregando"></loading>
        <vue-progress-bar></vue-progress-bar>
        <piweb-topo
            logoURL='/imgs/logo-menu.svg'
            nomeSistema="Auxílio - Estamos Juntos"
            :siglaSistema='sigla'
            homeLink="/"
            :itens-menu="itens_menu"
            :usuario="usuario"
            :logout-callback='logout'
            :fnLogout="logout"
        ></piweb-topo>                

        <div class="container conteudo">
            <piweb-breadcrumb siglaSistema='Auxílio - Estamos Juntos'></piweb-breadcrumb>
            <router-view></router-view>
        </div>

        <piweb-rodape
            logoURL='/imgs/logo-menu.svg'
            :versao='versao'
        ></piweb-rodape>

    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import loading from '../components/Loading';
import piwebTopo from '../components/layout/piweb-topo.vue';
import piwebRodape from '../components/layout/piweb-rodape.vue';
//import api from '../requests';

export default {

    components: {
        loading,
        piwebTopo,
        piwebRodape
    },
    
    methods: {
        logout() {
            // descomentar a linha abaixo para realizar o logout
            return this.$store.dispatch("LOGOUT_REQUEST");
        }
    },
    computed: {
        
        ...mapGetters(['isAuthenticated']),       

        sigla() {
            return process.env.MIX_APP_SIGLA || process.env.VUE_APP_SIGLA || '';
        },
        versao() {
            return this.$env.VUE_APP_VERSAO;
        },
        usuario() {
            //So obtem o usuario caso ele esteja autenticado com login do AD
            if(this.isAuthenticated && this.$store.getters.userInfo.origem === this.$constantes.usuario.ORIGEM_LOGIN_AD ){
                return { nomeCompleto: this.$store.getters.userInfo.name };
            }
            
            return {};
        },
        /**
         * Retorna os itens do menu
         */
        itens_menu() {

            let itens = [];  

            //MENU ADMIN
            //So exibe o menu administrativo para usuarios autenticados com login do AD
           
            if(this.isAuthenticated && this.$store.getters.userInfo.origem === this.$constantes.usuario.ORIGEM_LOGIN_AD ){              
                if(this.$store.getters.userRoles.length != 'undefined' && this.$store.getters.userRoles.length > 0){

                    if(this.$store.getters.userRoles.includes(this.$constantes.usuario.ROLES.SUPERADMINISTRADOR)){
                        itens.push({ 
                                        label: "Importações", 
                                        subitens: [
                                            { label: "Importação de Famílias", link: "/admin/importacao-familias" },
                                            //{ label: "Importar contas verificadas", link: "/admin/importacao-busca-contas" },
                                           // { label: "Importar contas criadas", link: "/admin/importacao-abertura-contas" },                         
                                        ]
                                    });

                        itens.push({ 
                                        label: "Exportações", 
                                        subitens: [
                                            { label: "Arquivo para busca de contas", link: "/admin/exportacao-familias-sem-conta" },
                                            { label: "Arquivo para criação de contas", link: "/admin/arquivo-criacao-conta" },                         
                                        ]
                                    });
                                    
                        itens.push({ 
                                        label: "Beneficiário",
                                        subitens: [
                                            { label: "Beneficiários", link: "/admin/beneficiarios" },
                                            { label: "Corrigir Pagamento", link: "/admin/configurar-pagamento" },
                                        ]
                                    });
                        itens.push({ 
                                        label: "Parâmetros", 
                                        subitens: [
                                            { label: "Abertura/Fechamento do Sistema", link: "/admin/parametros" }, 
                                            { label: "Gerar/Enviar Arquivo Pagamento", link: "/admin/visualizar-pagamento" },
                                            { label: "Gerar Parcela", link: "/admin/gerar-parcela" },
                                            { label: "Liberação Pagamento com Erro", link: "/admin/liberacao-pagamento-erro" },
                                            { label: "Data Pagamento", link: "/admin/parametros-pagamento" }, 
                                            { label: "Manutenção do Sistema", link: "/admin/manutencao" },              
                                        ]
                                    });
                        itens.push({ 
                                        label: "Relatórios", 
                                        subitens: [
                                            { label: "Beneficiários sem Conta", link: "/admin/relatorios" },  
                                            { label: "Status Pagamento", link: "/admin/relatorios/pagamentos-consolidados" },     
                                        ]
                                    });

                    }

                    if(this.$store.getters.userRoles.includes(this.$constantes.usuario.ROLES.ADMINISTRADOR) || 
                        this.$store.getters.userRoles.includes(this.$constantes.usuario.ROLES.CONSULTA) ||
                        this.$store.getters.userRoles.includes(this.$constantes.usuario.ROLES.ADMINISTRADOR_RF)){
                        if (itens.filter(i => i.label === 'Beneficiários').length == 0) {
                            itens.push({ label: "Beneficiários", link: "/admin/beneficiarios" });
                        }
                    }   
                }
            }         
    
            return itens;         
        }
    },
}
</script>

